export default __webpack_public_path__ + "static/media/box.52e6f495.webm";